module.exports = "pegasus/assets/theme6/google-icon-1.png";